import { Icon } from "@common/index";
import { NO_LOCATION_NOTE } from "../_helpers/noLocationCopy";
import { SupportLinkedText } from "./SupportLinkedText";

interface NoLocationNoteProps {
    // The sentence to carry. Defaults to the account-level note; the cart and
    // checkout pass NO_LOCATION_CART_NOTE, or NO_LOCATION_ORDER_BLOCKED when no
    // line is restricted (see noLocationCopy.ts).
    message?: string;
}

// The one informational note for a member seated on no location (#417) —
// rendered by the account dashboard, the membership page, the cart and
// checkout, keyed on membershipStatus === NoLocationMembership by each of
// them. role="status", info colour, no action button: it is neither an error
// nor a wall (see noLocationCopy.ts). "USNara support" links to the support
// page (#453).
export const NoLocationNote = ({
    message = NO_LOCATION_NOTE,
}: NoLocationNoteProps) => (
    // Explicit text-info-content: the light theme sets --color-base-content to
    // white (see the CLAUDE.md theme quirk), so an alert must never inherit a
    // base-content foreground. Same shape as OrderConfirmation's settlement note.
    <div
        role="status"
        data-testid="no-location-note"
        className="alert alert-info text-info-content"
    >
        <Icon name="info" filled />
        <span>
            <SupportLinkedText text={message} />
        </span>
    </div>
);
